/** A Design Studio editor URL; any one asks the same question of route ownership. */
const EDITOR_PROBE_PATH = '/workspaces/last/design-studio/editor/probe';

type ParentHydra = { __hydra__?: { isHydraRoute?: (path: string) => boolean } };

/**
 * Whether the iframe editors (`/design-studio-embed/cio/*`) render hydra's pages rather than parcel's
 * bundle. Their tree never loads the account, so they ask the hydra page that embeds them, which owns
 * the account and its `ds-editor-in-hydra` flag. With no hydra page to ask (not embedded, or the call
 * fails), they keep the bundle.
 */
export function isEmbedEditorInHydra(parent: ParentHydra | null = parentWindow()): boolean {
  try {
    return parent?.__hydra__?.isHydraRoute?.(EDITOR_PROBE_PATH) === true;
  } catch {
    return false;
  }
}

function parentWindow(): ParentHydra | null {
  if (typeof window === 'undefined' || window.parent === window) {
    return null;
  }
  return window.parent;
}
